import { render, staticRenderFns } from "./ShippingTable.vue?vue&type=template&id=7485ac6d&"
import script from "./ShippingTable.vue?vue&type=script&lang=js&"
export * from "./ShippingTable.vue?vue&type=script&lang=js&"
import style0 from "./ShippingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports